import { IdBot, IdConta, IdInbox } from "../common-types";
import { GenericService } from "../generic-service";

export type CreateBot = {
  nome: string;
  descricao?: string;
  idInbox: string;
  xInicio?: number;
  yInicio?: number;
  xTransladar?: number;
  yTransladar?: number;
  zoom?: number;
}

export type UpdateBot = Partial<CreateBot> & { id: IdBot }

export type ResponseBot = {
  id: IdBot;
  nome: string;
  descricao?: string;
  idInbox: string;
  xInicio?: number;
  yInicio?: number;
  xTransladar?: number;
  yTransladar?: number;
  zoom?: number;
  inbox: {
    id: IdInbox;
    nome: string;
  };
  tipo: string;
  del: boolean;
  copiado: boolean;
  criador?: { id: string; nome: string };
  dataCriacao?: string;
}
export class BotsService extends GenericService<CreateBot, UpdateBot, ResponseBot> {
  constructor() { super("bots") }

  async getByConta(idConta: IdConta) {
    return await this.f.get('', { idConta }, {resolve404AsValue: true, resolve404As: []}) as ResponseBot[];
  }

  async restore(id: IdBot) {
    return await this.f.patch(`${id}/restore`, {}) as ResponseBot[];
  }

  async clonar(idBotOrigem: string, idsInboxesDestino: string[]) {
    return await this.f.post('clonar', { 
      idBotOrigem,
      idsInboxesDestino,
    }) as ResponseBot[];
  }
}
